import React from "react";
import { Box, Button, Chip, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Ritual diário do piso: uma pergunta, respostas em chip, some com 1 clique.
 */
export default function VoFloorPrompt({
  prompt,
  answers = [],
  myAnswer = "",
  onAnswer,
  onDismiss,
  hidden = false,
}) {
  if (hidden || !prompt?.question) return null;
  return (
    <Box
      data-vo-floor-prompt={prompt.id}
      sx={{
        position: "relative",
        pointerEvents: "auto",
        width: "100%",
        px: { xs: 1.15, md: 1.5 },
        py: { xs: 0.9, md: 1.1 },
        borderRadius: 2,
        bgcolor: "rgba(24,20,18,0.72)",
        border: "1px solid rgba(255,255,255,0.12)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            sx={{
              fontSize: "0.68rem",
              fontWeight: 800,
              letterSpacing: "0.06em",
              wordSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#e8c48a",
              mb: 0.35,
            }}
          >
            Pergunta do piso
          </Typography>
          <Typography sx={{ fontSize: { xs: "0.84rem", md: "0.92rem" }, fontWeight: 700, color: "#f8f4ee", lineHeight: 1.3 }}>
            {prompt.question}
          </Typography>
        </Box>
        <IconButton
          size="small"
          aria-label="Ocultar pergunta do piso"
          onClick={onDismiss}
          sx={{ color: "rgba(255,255,255,0.7)", mt: -0.4 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
        {(prompt.answers || []).map((option) => {
          const selected = myAnswer === option;
          return (
            <Chip
              key={option}
              label={option}
              size="small"
              clickable={!selected}
              onClick={() => (selected ? null : onAnswer?.(option))}
              sx={{
                fontWeight: 700,
                color: selected ? "#202124" : "#f8f4ee",
                bgcolor: selected ? "#e8c48a" : "rgba(255,255,255,0.1)",
                border: selected ? "none" : "1px solid rgba(255,255,255,0.16)",
              }}
            />
          );
        })}
      </Stack>
      {answers.length ? (
        <Typography sx={{ mt: 0.85, fontSize: "0.72rem", color: "#d7cfc4", lineHeight: 1.4 }}>
          {answers
            .slice(0, 6)
            .map((item) => `${item.name}: ${item.answer}`)
            .join(" · ")}
        </Typography>
      ) : null}
      {myAnswer ? (
        <Button
          size="small"
          onClick={onDismiss}
          sx={{ mt: 0.5, minWidth: 0, px: 0, textTransform: "none", color: "#c4b8a8", fontWeight: 600 }}
        >
          Ocultar por hoje
        </Button>
      ) : null}
    </Box>
  );
}
